import { AVAILABLE_LANGUAGES } from '@redux/settings/settings.reducer';

export type LocaleType = { [key: string]: LocaleType | string };

export function flattenMessages(nestedMessages: LocaleType, prefix = '') {
  return Object.keys(nestedMessages).reduce((messages: Record<string, string>, key) => {
    const value = nestedMessages[key];
    const prefixedKey = prefix ? `${prefix}.${key}` : key;

    if (typeof value === 'string') {
      messages[prefixedKey] = value;
    } else {
      Object.assign(messages, flattenMessages(value, prefixedKey));
    }

    return messages;
  }, {});
}

export const truncateMessage = (message: string, maxLength: number) => {
  return message.length > maxLength ? `${message.slice(0, maxLength - 1)}...` : message;
};

type AvailableLanguage = Exclude<AVAILABLE_LANGUAGES, AVAILABLE_LANGUAGES.browser>;
export function isAvailableLanguage(value: string): value is AvailableLanguage {
  return Object.keys(AVAILABLE_LANGUAGES)
    .filter((language) => language !== AVAILABLE_LANGUAGES.browser)
    .includes(value);
}

export function getSettingsLocale(language: string): AvailableLanguage {
  const locale = language === AVAILABLE_LANGUAGES.browser ? navigator.language.split('-')[0] : language;
  return isAvailableLanguage(locale) ? locale : AVAILABLE_LANGUAGES.en;
}

export const CONTACT_LOCALES = ['fr', 'en'] as const;

export const CONTACT_TIMEZONES = [
  'UTC',
  'Pacific/Pago_Pago',
  'Pacific/Honolulu',
  'America/Los_Angeles',
  'America/Denver',
  'America/Chicago',
  'America/New_York',
  'America/St_Johns',
  'America/Sao_Paulo',
  'Europe/London',
  'Europe/Paris',
  'Europe/Athens',
  'Europe/Moscow',
  'Asia/Tehran',
  'Asia/Dubai',
  'Asia/Kolkata',
  'Asia/Kathmandu',
  'Asia/Bangkok',
  'Asia/Shanghai',
  'Asia/Tokyo',
  'Australia/Adelaide',
  'Australia/Sydney',
  'Pacific/Auckland',
  'Pacific/Kiritimati',
] as const;

export function getBrowserContactLocale(): (typeof CONTACT_LOCALES)[number] {
  return navigator.language.startsWith('fr') ? 'fr' : 'en';
}

export function getBrowserTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
